/* eslint-disable @typescript-eslint/no-floating-promises */
import { RefObject } from 'react';
import { UserDocumentPresignedDto } from '../../../commonTypes/user.types';
import { useContainer } from '../../useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { useTranslation } from '../../useTranslation';

const useHttpShowUserDocument = () => {
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const showUserDocument = (id: string, download: boolean, anchorRef: RefObject<HTMLAnchorElement>) => {
        const { exec } = userApi.getUserDocument({
            params: { id },
            query: { presign: true },
            onSuccess: res => {
                const body = res.body as UserDocumentPresignedDto;
                if (!anchorRef.current) return;

                anchorRef.current.removeAttribute('download');
                anchorRef.current.removeAttribute('target');
                anchorRef.current.setAttribute('target', '_blank');

                if (!download) {
                    anchorRef.current.href = body.presignedUrl;
                    anchorRef.current.click();
                    return;
                }

                fetch(body.presignedUrl)
                    .then(response => response.blob())
                    .then(blob => {
                        if (!anchorRef.current) return;
                        const url = window.URL.createObjectURL(blob);

                        anchorRef.current.setAttribute('download', body.name);
                        anchorRef.current.setAttribute('href', url);
                        anchorRef.current.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(err => {
                        console.log(err);
                        toastHandler.push(`error`, t('common.error'), t('common.somethingWentWrong'));
                    });
            },
            onError: () => toastHandler.push(`error`, t('common.error'), t('common.somethingWentWrong')),
        });
        exec();
    };

    return { showUserDocument };
};

export default useHttpShowUserDocument;
